(() => {
  function normalizeText(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function isSoldOutBadge(el) {
    if (!el) return false;

    const text = normalizeText(el.textContent);

    return (
      text.includes('agotado') ||
      text.includes('sold out') ||
      text.includes('sin stock') ||
      text.includes('out of stock')
    );
  }

  function removeSoldOutBadges(root = document) {
    root.querySelectorAll('.badge, .card__badge .badge, .product__badge, [class*="badge"]').forEach((badge) => {
      if (isSoldOutBadge(badge)) {
        badge.remove();
      }
    });
  }

  function getStockData(scopeEl) {
    const jsonEl = scopeEl.querySelector('.ponte-variant-stock');
    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch {
      return null;
    }
  }

  function findScope(fromEl) {
    const modal = fromEl.closest('.quick-add-modal, modal-dialog');
    if (modal) return modal;

    const card = fromEl.closest('.card');
    if (card) return card;

    const product = fromEl.closest('product-info, .product, .product-form');
    if (product) return product;

    return document;
  }

  function findBadgeSpan(scope) {
    return scope.querySelector('.card__badge .badge:not(.ponte-badge--low-stock)');
  }

  function updateBadgeForVariant(scope, variantId) {
    removeSoldOutBadges(scope);

    const data = getStockData(scope);
    if (!data) return;

    const badgeWrap = scope.querySelector('.card__badge');
    if (!badgeWrap) return;

    const variant = data.variants?.[String(variantId)];
    if (!variant) return;

    const shouldShowLow =
      variant.managed === true &&
      variant.available === true &&
      Number(variant.qty) > 0 &&
      Number(variant.qty) <= Number(data.threshold);

    let badge = findBadgeSpan(scope);

    const isSale =
      badge?.className.includes('sale_badge_color_scheme') ||
      normalizeText(badge?.textContent).includes('sale') ||
      normalizeText(badge?.textContent).includes('oferta');

    if (shouldShowLow) {
      if (!badge || isSale) {
        const newBadge = document.createElement('span');
        newBadge.className = 'badge badge--bottom-left ponte-badge--low-stock';
        newBadge.textContent = 'Bajas existencias';
        badgeWrap.insertBefore(newBadge, badgeWrap.firstChild);
      } else {
        badge.classList.add('ponte-badge--low-stock');
        badge.textContent = 'Bajas existencias';
      }
    } else {
      const low = badgeWrap.querySelector('.ponte-badge--low-stock');
      if (low) low.remove();
    }

    removeSoldOutBadges(scope);
  }

  function init() {
    removeSoldOutBadges();

    document.addEventListener('change', (e) => {
      const el = e.target;

      if (!(el instanceof HTMLInputElement)) return;
      if (el.name !== 'id') return;

      const scope = findScope(el);
      if (!scope) return;

      updateBadgeForVariant(scope, el.value);
      removeSoldOutBadges();
    });

    document.addEventListener('click', () => {
      window.setTimeout(() => {
        removeSoldOutBadges();
      }, 80);

      window.setTimeout(() => {
        removeSoldOutBadges();
      }, 250);
    });

    document.addEventListener('variant:change', () => {
      window.setTimeout(() => {
        removeSoldOutBadges();
      }, 80);

      window.setTimeout(() => {
        removeSoldOutBadges();
      }, 250);
    });

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (!(n instanceof HTMLElement)) continue;

          removeSoldOutBadges(n);

          const modal = n.matches?.('.quick-add-modal, modal-dialog')
            ? n
            : n.querySelector?.('.quick-add-modal, modal-dialog');

          if (!modal) continue;

          const idInput = modal.querySelector('input[name="id"]');
          if (idInput?.value) updateBadgeForVariant(modal, idInput.value);
        }
      }

      removeSoldOutBadges();
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(removeSoldOutBadges, 100);
    window.setTimeout(removeSoldOutBadges, 300);
    window.setTimeout(removeSoldOutBadges, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();